import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSearchPageFilters } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import recordSearchQuery from "@faire/web-api--source/endpoints/www/api/v2/search/record-search-query/post";
import { IRecordSearchedQueryRequest } from "@faire/web-api--source/indigofair/data/IRecordSearchedQueryRequest";
import { useEffect } from "react";

export const useSearchPageLogLastQueryEffect = () => {
  const lastQuery = useSearchPageProductSearchString();
  const filters = useSearchPageFilters();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  useEffect(() => {
    if (isLoggedInRetailer) {
      logLastQuery(lastQuery ?? "", filters);
    }
  }, [lastQuery, filters, isLoggedInRetailer]);

  return null;
};

async function logLastQuery(lastQuery: string, filters: string[]) {
  await recordSearchQuery(
    IRecordSearchedQueryRequest.build({
      query: lastQuery,
      filter_keys: filters,
    })
  );
}
